/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 11:07:12
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-30 11:26:27
 */
// import ReactDOM from "react-dom";
import "@/styles/reset.less";
import "@/assets/iconfont/iconfont.less";
import "@/assets/fonts/font.less";
// import "antd/dist/antd.less";
import "@/styles/common.less";
// import "@/styles/global.scss";
import "@/language/index";
import "virtual:svg-icons-register";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
// import { store, persistor } from "@/redux";
import { store } from "@/redux";

import App from "@/App";

import ReactDOM from "react-dom/client";
// react 18 创建（会导致 antd 菜单折叠时闪烁，等待官方修复）
ReactDOM.createRoot(document.getElementById("root")!).render(
	// * react严格模式
	// <React.StrictMode>
	<Provider store={store}>
		{/* <PersistGate persistor={persistor}> */}
		<App />
		{/* </PersistGate> */}
	</Provider>
	// </React.StrictMode>
);
